export const MODULES = '/modules/create'
export const MODULES_CREATE = `${MODULES}/create`
